import { render, staticRenderFns } from "./Addstore.vue?vue&type=template&id=44b3cc36&"
import script from "./Addstore.vue?vue&type=script&lang=js&"
export * from "./Addstore.vue?vue&type=script&lang=js&"
import style0 from "./Addstore.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports